import DataTableComponent from "../../../tools/DataTableComponent";

const TransfertTable = ({ documents, panier, mode, loading, onDetail }) => {

  const columns = ["numero", "tier", "dateDocument", "nbLignes"];
  const columnsMapping = {
    numero: "Numéro",
    tier: mode === "achat" ? "Fournisseur" : "Client",
    dateDocument: "Date Création",
    nbLignes: "Lignes sélectionnées"
  };

console.log("documents",documents)
  const documentsWithCount = documents.map(doc => {
    const existing = panier.find(
      p => p.sourceDocumentId === doc.id
    );

       return {
      ...doc,
      nbLignes: existing ? existing.lignes.length : 0
    };
  });
  return (
    <DataTableComponent
      title="Documents"
      columns={columns}
      columnsMapping={columnsMapping}
      keyField="id"
      data={documentsWithCount}
      progressPending={loading}
      handleDetail={onDetail}
    />
  );
};

export default TransfertTable;